module.exports = __webpack_public_path__ + "img/Yellow_Space_Invader.c519ec19.gif";